import { FormikProvider, useFormik, Field, ErrorMessage } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Row, Col, Form, Button } from "react-bootstrap";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";

export default function TypeConversionApplicationDetails() {

    const [instType, setInstType] = useState("");
    const [conversionType, setConversionType] = useState("yes");
    const [isSubmitted, setIsSubmitted] = useState(false);

    const initialValues = {
        justification: ""
    };

    const validationSchema = Yup.object({
        justification: Yup.string()
            .required("Justification is required")
            .min(20, "Justification must be at least 20 characters")
    });

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (values) => handleFormSubmit(values)
    });

    const handleConversionChange = (e) => {
        setConversionType(e.target.value);
    };

    const handleFormSubmit = (values) => {

        Swal.fire({
            title: "Are you sure?",
            text: `Do you want to change the institution type from ${instType === "Co_Education" ? "Co-Education institution" : "Women's institution"
                } to ${instType === "Co_Education" ? "Women's institution" : "Co-Education institution"
                }?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, Submit"
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = {
                    justification: values.justification,
                    typeRadio: conversionType === "yes" ? "Option1" : "Option2"
                };
                CommonAxiosPost(config.url.FAC_URL + "saveTypeConversion", payload)
                    .then((res) => {


                        if (res.data.scode === "01") {

                            successAlert2(res.data.sdesc);

                            setIsSubmitted(true);

                            setTimeout(() => {
                                window.location.reload();
                            }, 1500);

                        } else {
                            failureAlert("Failed", res.data.sdesc);
                        }

                    })
                    .catch((error) => {

                        console.log("API ERROR:", error);
                        console.log("ERROR RESPONSE:", error.response);

                        Swal.fire("Error", "Network error", "error");

                    });
            }

        });
    };

    function getTypeConversion() {

        let url = config.url.FAC_URL + "getTypeConversion";

        CommonAxiosGet(url)
            .then((res) => {

                if (res?.data?.status === true && res.data.typeConversion?.length > 0) {

                    const data = res.data.typeConversion[0];

                    formik.setFieldValue("justification", data.justification || "");
                    if (data.typeRadio === "Option1" || data.typeradio === "Option1") {
                        setConversionType("yes");
                    } else if (data.typeRadio === "Option2") {
                        setConversionType("no");
                    }
                    setIsSubmitted(true);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function getBasicDetails() {

        let url = config.url.FAC_URL + "getSocietyDetails";

        CommonAxiosGet(url).then((res) => {

            if (res?.data?.status === true) {

                const data = res.data.data;

                if (data.length > 0) {

                    const item = data[0];

                    setInstType(item.inst_type);
                }
            }
        });
    }

    useEffect(() => {
        getBasicDetails();
        getTypeConversion();
    }, []);

    return (
        <>
            <FormikProvider value={formik}>

                <Form onSubmit={formik.handleSubmit}>

                    <h5 className="mb-3 innerheader-new">
                        <span>🔄 <b>Conversion of the Institution</b></span>
                    </h5>

                    <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                        Current Institution Type : {instType}
                    </div>

                    <div style={{ marginBottom: "10px" }}>

                        {/* {instType === "Co_Education" &&
                            "Do you want to convert it to Women Institution?"}

                        {instType !== "Co_Education" &&
                            "Do you want to convert it to Co-Education Institution?"} */}
                        {(instType === "Co_Education" || instType === "Co-Education") &&
                            "Do you want to convert it to Women Institution?"}

                        {!(instType === "Co_Education" || instType === "Co-Education") &&
                            "Do you want to convert it to Co-Education Institution?"}
                    </div>

                    <div
                        style={{
                            background: "#f8f9fa",
                            padding: "15px",
                            borderRadius: "8px",
                            marginBottom: "20px"
                        }}
                    >

                        <input
                            type="radio"
                            name="conversionType"
                            value="yes"
                            checked={conversionType === "yes"}
                            onChange={handleConversionChange}
                            disabled={isSubmitted}
                        />

                        <label style={{ marginLeft: "6px", marginRight: "20px" }}>
                            Yes
                        </label>

                        <input
                            type="radio"
                            name="conversionType"
                            value="no"
                            checked={conversionType === "no"}
                            onChange={handleConversionChange}
                            disabled={isSubmitted}
                        />

                        <label style={{ marginLeft: "6px" }}>
                            No
                        </label>

                    </div>

                    {/* Justification */}

                    <Row>
                        <Col md={8}>
                            <Form.Group>

                                <Form.Label>
                                    <b>📝 Justification *</b>
                                </Form.Label>

                                <Field
                                    name="justification"
                                    as="textarea"
                                    rows={4}
                                    className="form-control"
                                    placeholder="Enter justification"
                                    disabled={isSubmitted}
                                    style={{ height: "120px", resize: "vertical" }}
                                />

                                <ErrorMessage
                                    name="justification"
                                    component="div"
                                    className="text-danger"
                                />

                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Submit Button */}

                    {!isSubmitted ? (

                        <Row className="mt-4">
                            <Col className="text-end">

                                <Button
                                    type="submit"
                                    variant="primary"
                                >
                                    Submit
                                </Button>

                            </Col>
                        </Row>

                    ) : (

                        <Row className="mt-4">
                            <Col className="text-end">

                                <div style={{ color: "green", fontWeight: "bold" }}>
                                    ✅ Already submitted
                                </div>

                            </Col>
                        </Row>

                    )}

                </Form>

            </FormikProvider>
        </>
    );
}